/**
 * Shared vendor libraries (App.js & public_pages/*.js)
 *
 * @attention Adding/Importing a npm module here means that you have to
 * add it to const vendors = [...] in gulpfile.js as well (so that it's
 * import in other files can be skipped)
 *
 * @todo Analyzing the source-maps, you will find that this tree-shaking approach
 * brings in some troubles (e.g. local modules marked as "// modified" are always bundled)
 * Solution a):
 *      I) Reduce the imports/exports below to all core-modules.
 *         All non-core-modules have to be imported explicitly
 *      II) Implement async import of controllers & views
 */
import _ from "underscore";
import Backbone from "backbone";
import $ from "jquery";

// Foundation + Legacy-Libraries require jQuery as a global variable (window.jQuery) and Backbone expects window.Backbone.
window.$ = window.jQuery = $;

import Marionette from "backbone.marionette";
import AppRouter from "marionette.approuter";
import Obscura from "./Backbone.Obscura"; // modified
import Async from "backbone.async";
import Radio from "backbone.radio";
import Foundation from "foundation-sites";
import moment from "moment/min/moment-with-locales";
import Datepicker from "pikaday";
import underi18n from "./underi18n"; // modified
import GoogleMaps from "google-maps";
import select2 from "./select2"; // modified
import sha1 from "js-sha1";
import CountryList from "i18n-iso-countries";
import enLocale from "i18n-iso-countries/langs/en.json";
import frLocale from "i18n-iso-countries/langs/fr.json";
import deLocale from "i18n-iso-countries/langs/de.json";
// import * as Sentry from '@sentry/browser'
import React from "react";
import ReactDOM from "react-dom";
import DropdownButton from "react-bootstrap/DropdownButton";
import Dropdown from "react-bootstrap/Dropdown";
import { Remarkable } from "remarkable";
import autobahn from "autobahn";

Backbone.$ = $;

CountryList.registerLocale(enLocale);
CountryList.registerLocale(frLocale);
CountryList.registerLocale(deLocale);

export {
  _,
  $,
  Backbone,
  Marionette,
  AppRouter,
  Obscura,
  Async,
  Radio,
  Foundation,
  moment,
  Datepicker,
  underi18n,
  GoogleMaps,
  select2,
  CountryList,
  sha1,
  // Sentry,
  React,
  ReactDOM,
  DropdownButton,
  autobahn,
  Remarkable,
  Dropdown,
};
